import {StrMap} from "../interfaces/common";

export const translateName = (name: string, language: string, languageMap: StrMap) => {
  if (languageMap[language]) {
    return languageMap[language];
  }
  return name;
}